import { render, staticRenderFns } from "./DnsListBatchWise.vue?vue&type=template&id=c80900ba&scoped=true"
import script from "./DnsListBatchWise.vue?vue&type=script&lang=js"
export * from "./DnsListBatchWise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80900ba",
  null
  
)

export default component.exports